var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98424 15.1799H9.99724C13.4621 15.1799 15.0285 13.7727 15.1701 10.502C15.1899 10.4485 15.2008 10.3908 15.2008 10.3309C15.2008 10.2809 15.1932 10.2326 15.1793 10.1868C15.1802 10.124 15.1807 10.0606 15.1807 9.99646V5.98346C15.1807 2.3517 13.629 0.800003 9.99724 0.800003H5.98424C2.35247 0.800003 0.800781 2.3517 0.800781 5.98346V9.99646C0.800781 13.6282 2.35247 15.1799 5.98424 15.1799ZM14.1774 9.82925V5.98346C14.1774 2.90014 13.0806 1.80325 9.99724 1.80325H5.98424C2.90092 1.80325 1.80403 2.90014 1.80403 5.98346V9.82925H14.1774ZM14.1462 10.8325H1.83532C2.03363 13.2808 3.19774 14.1767 5.98424 14.1767H9.99724C12.7837 14.1767 13.9478 13.2808 14.1462 10.8325Z",
    fill: "#2D3136"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProducts);
export default __webpack_public_path__ + "static/media/my-products.0959cf671a6b5aea8959ef5290c89a8c.svg";
export { ForwardRef as ReactComponent };